import { Link } from "react-router-dom";

const COLS = [
  {
    title: "SHOP",
    links: [
      { label: "The Shelf", to: "/#shelf" },
      { label: "First Access", to: "/#drop-list" },
      { label: "Contact", to: "/contact" },
    ],
  },
  {
    title: "SUPPORT",
    links: [
      { label: "Order Status", to: "/order-status" },
      { label: "Shipping & Returns", to: "/policies/shipping-returns" },
    ],
  },
  {
    title: "LEGAL",
    links: [
      { label: "Privacy Policy", to: "/policies/privacy" },
      { label: "Terms", to: "/policies/terms" },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-ll-line bg-ll-black">
      <div className="mx-auto max-w-7xl px-5 py-16 md:px-8">
        <div className="grid gap-12 md:grid-cols-[1.5fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center">
              <span className="font-display text-3xl tracking-[0.12em]">ETERNEL</span>
            </div>
            <p className="mt-4 max-w-xs text-sm text-ll-steel">
              Aesthetic room decor — LED clocks, neon signs, canvas art, rugs and mirrors that make a room feel like yours.
            </p>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <p className="font-tech text-[11px] tracking-[0.25em] text-ll-steel">{col.title}</p>
              <ul className="mt-4 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a data-testid={`footer-${l.label.toLowerCase().replace(/[\s&]/g, "-")}`} href={l.to}
                       className="text-sm text-ll-bone/80 transition-colors duration-200 hover:text-ll-red">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-16 flex flex-col gap-2 border-t border-ll-line pt-6 md:flex-row md:items-center md:justify-between">
          <p className="font-tech text-[11px] tracking-[0.2em] text-ll-steel">© 2026 ETERNEL</p>
          <p className="font-tech text-[11px] tracking-[0.2em] text-ll-steel">DECOR THAT CHANGES THE ROOM</p>
        </div>
      </div>
      <div className="pointer-events-none select-none overflow-hidden" aria-hidden="true">
        <p className="text-outline -mb-[4vw] text-center font-display text-[19vw] leading-[0.8]">ETERNEL</p>
      </div>
    </footer>
  );
}
